(function () {
    'use strict';

    angular
        .module('spidwebApp')
        .factory('flavorService', flavorService);

    flavorService.$inject = ['axiosService', 'masterdatasCache', 'envService'];

    function flavorService(axiosService, masterdatasCache, envService) {

        return {
            getFlavors: function (locale) {
                return axiosService
                    .get(
                        envService.getOfferDatasContext() +
                            '/flavors?' +
                            Object.entries({ locale })
                                .map(([key, val]) => `${key}=${val}`)
                                .join('&'),
                        {
                            withCredentials: true,
                            cache: masterdatasCache,
                            headers: {
                                Accept: 'application/json;charset=UTF-8',
                            },
                        }
                    )
                    .then(function (response) {
                        return response.data;
                    });
            }
        };

    }

})();
